module.exports = __webpack_public_path__ + "static/media/WiseUp.a88b86c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/clients/WiseUp.png
// module id = 363
// module chunks = 0